import * as React from "react";

import CourseOutcome from "../../../assets/pdf/ME.pdf";
import CourseOutcomeAuto from "../../../assets/pdf/bvocAuto.pdf";
import CourseOutcomeDip from "../../../assets/pdf/Diploma_ME.pdf";
import lateralData from "../../../assets/pdf/BtechLateralEntry.pdf";

export const BtechME = () => {
  return (
    <div>
      <div className="xs:px-4">
        <div className="md:px-[24px] lg:px-0">
          <a href={lateralData} target="_blank" rel="noreferrer">
            <div className="mt-16 text-lg font-semibold text-[#003857] cursor-pointer underline">
              B.TECH (ME) Lateral Entry also available
            </div>
          </a>
          <div className="primary-color container mt-8 ml-0 w-72  border-l-4 border-[#32727a]  pl-3 text-3xl font-bold xxs:w-[90%]  xs:mt-10 xs:w-[95%] xs:text-4xl sm:w-[70%] lg:w-[85%] lg:text-5xl xl:w-[65%] 2xl:w-[50%]">
            Mechanical Engineering
          </div>
          <div className="mt-14 grid grid-cols-1 gap-4 text-white sm:px-10  md:px-0 lg:grid-cols-3 lg:gap-9">
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              Duration: 4 years ( 8 Semesters)
            </div>
            <div className="secondary-bg-color  h-16 items-center rounded-md p-4 text-center text-lg">
              Eligibility: 10 + 2 (NON-MEDICAL)
            </div>
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              No of seats: 30
            </div>
          </div>
          <div className=" mt-6">
            <div className="text-2xl font-semibold text-[#003857]">
              Program Specific Outcomes
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO1: </span>Apply the
              fundamentals of mathematics, science and engineering to solve the
              engineeringproblems of design, production, quality and
              manufacturing pertaining to core and related engineeringdomain.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO2: </span>Accomplish the
              professional task with managerial attributes and engineering
              skills in an ethicaland responsible manner.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO3: </span>Demonstrate
              motivation towards pursuing higher education in the institutes of
              national andglobal repute to deal with prevalent / emerging needs
              of society and industry.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO4: </span>Pursue their career
              in the reputed organizations engaged in the manufacturing, design
              and otherassociated fields
            </div>
            <div className="">
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                Course Rationale
              </div>
              <div className=" mt-1 break-words text-justify text-lg tracking-wider">
                Mechanical Engineering has been the medium through which the
                single most important socio-economicrevolution known as the
                Industrial Revolution had found its expression in the 19 th
                century. Because of the higherlevel of instrumentation,
                automation and computerization of the products and processes,
                there has been anenormous development and refinement in
                manufacturing technology. Manufacturing engineers are required
                byall kinds of companies which manufacture a great variety of
                machines, robotics and other equipment. Amanufacturing engineer
                may be responsible for the design, selection of materials,
                specifications and theimprovement of production processes and
                equipment.
              </div>
            </div>
            <div className="">
              <a href={CourseOutcome} target="_blank" rel="noreferrer">
                <div className="mt-8 text-2xl font-semibold text-[#003857] underline cursor-pointer">
                  Course Outcome
                </div>
              </a>
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                CAREER OPPORTUNITIES
              </div>
              <div className="mt-1 break-words text-lg tracking-wider">
                Mechanical Engineers are hired in thermal power industry, gas
                turbines industry, air conditioning andrefrigeration industry,
                oil and gas exploration and refining industries, agricultural
                sector, educational sector,aviation companies, shipping
                industries, aerospace industry, armed forces, pharmaceutical,
                automobile industryand many other government sectors.
              </div>
              <ul className="list-disc pl-4 text-justify text-[17px]">
                <li>Computer Aided Designing and Manufacturing</li>
                <li>Product Engineering Industry</li>
                <li>Defence Industry</li>
                <li>Aviation Industry</li>
                <li>Maintenance Industry</li>
                <li>Infrastructure Industry</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const BVOCAutomobileTab = () => {
  return (
    <div>
      <div className="xs:px-4">
        <div className="md:px-[24px] lg:px-0">
          <div className="primary-color container mt-8 ml-0 w-72  border-l-4 border-[#32727a]  pl-3 text-3xl font-bold xxs:w-[90%]  xs:mt-20 xs:w-[95%] xs:text-4xl sm:w-[70%]  lg:text-5xl ">
            B.VOC (Automobile Services)
          </div>
          <div className="mt-14 grid grid-cols-1 gap-4 text-white sm:px-10  md:px-0 lg:grid-cols-3 lg:gap-9">
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              Duration: 4 years ( 8 Semesters)
            </div>
            <div className="secondary-bg-color  h-16 items-center rounded-md p-4 text-center text-lg">
              Eligibility: 10 + 2 (Any Stream)
            </div>
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              No of seats: 30
            </div>
          </div>
          <div className=" mt-6">
            <div className="text-2xl font-semibold text-[#003857]">
              Program Specific Outcomes
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO1: </span>Apply the
              fundamentals of mathematics, science and engineering to solve the
              engineeringproblems of design, production, quality and
              manufacturing pertaining to core and related engineeringdomain.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO2: </span>Accomplish the
              professional task with managerial attributes and engineering
              skills in an ethicaland responsible manner.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO3: </span>Demonstrate
              motivation towards pursuing higher education in the institutes of
              national andglobal repute to deal with prevalent / emerging needs
              of society and industry.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO4: </span>Pursue their career
              in the reputed organizations engaged in the manufacturing, design
              and otherassociated fields
            </div>
            <div className="">
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                Course Rationale
              </div>
              <div className=" mt-1 break-words text-justify text-lg tracking-wider">
                Mechanical Engineering has been the medium through which the
                single most important socio-economicrevolution known as the
                Industrial Revolution had found its expression in the 19 th
                century. Because of the higherlevel of instrumentation,
                automation and computerization of the products and processes,
                there has been anenormous development and refinement in
                manufacturing technology. Manufacturing engineers are required
                byall kinds of companies which manufacture a great variety of
                machines, robotics and other equipment. Amanufacturing engineer
                may be responsible for the design, selection of materials,
                specifications and theimprovement of production processes and
                equipment.
              </div>
            </div>
            <div className="">
              <a href={CourseOutcomeAuto} target="_blank" rel="noreferrer">
                <div className="mt-8 text-2xl font-semibold text-[#003857] underline cursor-pointer">
                  Course Outcome
                </div>
              </a>
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                CAREER OPPORTUNITIES
              </div>
              <div className="mt-1 break-words text-lg tracking-wider">
                Mechanical Engineers are hired in thermal power industry, gas
                turbines industry, air conditioning andrefrigeration industry,
                oil and gas exploration and refining industries, agricultural
                sector, educational sector,aviation companies, shipping
                industries, aerospace industry, armed forces, pharmaceutical,
                automobile industryand many other government sectors.
              </div>
              <ul className="list-disc pl-4 text-justify text-[17px]">
                <li>Computer Aided Designing and Manufacturing</li>
                <li>Product Engineering Industry</li>
                <li>Defence Industry</li>
                <li>Aviation Industry</li>
                <li>Maintenance Industry</li>
                <li>Infrastructure Industry</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const DiplomaME = () => {
  return (
    <div>
      <div className="xs:px-4">
        <div className="md:px-[24px] lg:px-0">
          <div className="primary-color container mt-8 ml-0 w-72  border-l-4 border-[#32727a]  pl-3 text-3xl font-bold xxs:w-[90%]  xs:mt-20 xs:w-[95%] xs:text-4xl sm:w-[70%]  lg:text-5xl ">
            Diploma (Mechanical Engineering)
          </div>
          <div className="mt-14 grid grid-cols-1 gap-4 text-white sm:px-10  md:px-0 lg:grid-cols-3 lg:gap-9">
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              Duration: 3 years ( 6 Semesters)
            </div>
            <div className="secondary-bg-color  h-16 items-center rounded-md p-4 text-center text-lg">
              Eligibility: 10th
            </div>
            <div className="secondary-bg-color  h-16 rounded-md p-4 text-center text-lg">
              No of seats: 30
            </div>
          </div>
          <div className=" mt-6">
            <div className="text-2xl font-semibold text-[#003857]">
              Program Specific Outcomes
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO1: </span>Apply the
              fundamentals of mathematics, science and engineering to solve the
              engineeringproblems of design, production, quality and
              manufacturing pertaining to core and related engineeringdomain.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO2: </span>Accomplish the
              professional task with managerial attributes and engineering
              skills in an ethicaland responsible manner.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO3: </span>Demonstrate
              motivation towards pursuing higher education in the institutes of
              national andglobal repute to deal with prevalent / emerging needs
              of society and industry.
            </div>
            <div className="mt-6 break-words text-justify text-lg tracking-wider">
              <span className=" font-semibold">PSO4: </span>Pursue their career
              in the reputed organizations engaged in the manufacturing, design
              and otherassociated fields
            </div>
            <div className="">
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                Course Rationale
              </div>
              <div className=" mt-1 break-words text-justify text-lg tracking-wider">
                Mechanical Engineering has been the medium through which the
                single most important socio-economicrevolution known as the
                Industrial Revolution had found its expression in the 19 th
                century. Because of the higherlevel of instrumentation,
                automation and computerization of the products and processes,
                there has been anenormous development and refinement in
                manufacturing technology. Manufacturing engineers are required
                byall kinds of companies which manufacture a great variety of
                machines, robotics and other equipment. Amanufacturing engineer
                may be responsible for the design, selection of materials,
                specifications and theimprovement of production processes and
                equipment.
              </div>
            </div>
            <div className="">
              <a href={CourseOutcomeDip} target="_blank" rel="noreferrer">
                <div className="mt-8 text-2xl font-semibold text-[#003857] underline cursor-pointer">
                  Course Outcome
                </div>
              </a>
              <div className="mt-8 text-2xl font-semibold text-[#003857]">
                CAREER OPPORTUNITIES
              </div>
              <div className="mt-1 break-words text-lg tracking-wider">
                Mechanical Engineers are hired in thermal power industry, gas
                turbines industry, air conditioning andrefrigeration industry,
                oil and gas exploration and refining industries, agricultural
                sector, educational sector,aviation companies, shipping
                industries, aerospace industry, armed forces, pharmaceutical,
                automobile industryand many other government sectors.
              </div>
              <ul className="list-disc pl-4 text-justify text-[17px]">
                <li>Computer Aided Designing and Manufacturing</li>
                <li>Product Engineering Industry</li>
                <li>Defence Industry</li>
                <li>Aviation Industry</li>
                <li>Maintenance Industry</li>
                <li>Infrastructure Industry</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
